import { AdminLayout } from "@/components/Admin/AdminLayout"
import { Card } from "@/components/ui/card"
import { Link, router } from "@inertiajs/react"

interface ResultItem {
  id: number
  user_email?: string | null
  user_name?: string | null
  tipo_eneagrama?: number | null
  fim_at?: string | null
  advanced_fim_at?: string | null
  microperfil?: string | null
  created_at: string
}

interface Props {
  results: ResultItem[]
  filters: {
    tipo?: string | null
  }
  stats: Record<string, number>
}

const formatDateTime = (value?: string | null) => {
  if (!value) return "-"
  const date = new Date(value)
  return new Intl.DateTimeFormat("pt-BR", {
    dateStyle: "short",
    timeStyle: "short",
  }).format(date)
}

export default function TestResultsIndex({ results, filters, stats }: Props) {
  const tipoOptions = Object.keys(stats).sort((a, b) => parseInt(a) - parseInt(b))

  return (
    <AdminLayout title="Resultados">
      <Card className="p-4 md:p-6">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-4">
          <h2 className="text-lg font-semibold">Resultados do teste</h2>
          <div className="flex items-center gap-2">
            <label className="text-sm text-muted-foreground">Tipo</label>
            <select
              value={filters.tipo || ""}
              onChange={(event) => {
                const value = event.target.value
                router.get("/admin/test_results", { tipo: value || undefined }, { preserveScroll: true })
              }}
              className="border rounded-md px-3 py-2 text-sm bg-white"
            >
              <option value="">Todos</option>
              {tipoOptions.map((tipo) => (
                <option key={tipo} value={tipo}>Tipo {tipo}</option>
              ))}
            </select>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-6 gap-2 mb-4 text-xs text-muted-foreground">
          {tipoOptions.map((tipo) => (
            <div key={`stats-${tipo}`} className="bg-muted/50 rounded-md px-3 py-2">
              Tipo {tipo}: <span className="font-semibold text-foreground">{stats[tipo]}</span>
            </div>
          ))}
        </div>

        <div className="overflow-x-auto">
          <table className="min-w-full text-sm">
            <thead>
              <tr className="text-left text-muted-foreground border-b">
                <th className="py-2 pr-4">ID</th>
                <th className="py-2 pr-4">Nome</th>
                <th className="py-2 pr-4">Email</th>
                <th className="py-2 pr-4">Tipo</th>
                <th className="py-2 pr-4">Concluído</th>
                <th className="py-2 pr-4">Avançado</th>
                <th className="py-2 pr-4">Microperfil</th>
                <th className="py-2">Ações</th>
              </tr>
            </thead>
            <tbody>
              {results.map((result) => (
                <tr key={result.id} className="border-b last:border-0">
                  <td className="py-2 pr-4">#{result.id}</td>
                  <td className="py-2 pr-4">{result.user_name || "—"}</td>
                  <td className="py-2 pr-4">{result.user_email || "—"}</td>
                  <td className="py-2 pr-4">{result.tipo_eneagrama || "—"}</td>
                  <td className="py-2 pr-4">{formatDateTime(result.fim_at)}</td>
                  <td className="py-2 pr-4">{formatDateTime(result.advanced_fim_at)}</td>
                  <td className="py-2 pr-4">{result.microperfil || "—"}</td>
                  <td className="py-2">
                    <Link href={`/admin/test_results/${result.id}`} className="text-primary hover:underline">
                      Ver detalhes
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card>
    </AdminLayout>
  )
}
